import { render } from "./eb-page-header.vue?vue&type=template&id=750cd5e4"
import script from "./eb-page-header.vue?vue&type=script&lang=ts"
export * from "./eb-page-header.vue?vue&type=script&lang=ts"
script.render = render

export default script